import React, { useState } from 'react';
import { t } from 'i18next';

import styles from './HeroSectionForCancellation.module.css';
import BubbleButton from '../../UI/Buttons/BubbleButton/BubbleButton';
import FormSelectField from '../../UI/FormUI/FormSelectField/FormSelectField';
import {
    HeroSectionCircle1,
    HeroSectionCircle2,
    HeroSectionCircle3,
    HeroSectionCircle4,
} from '../../../assets/images/icons';

function HeroSectionForCancellation({ title, desc, finish_callback, claim, onSubmit, ...props }) {
    // Dropdown options
    const dropdownOptions = [
        { label: t('general.UI.keepSubscription'), value: 'keep' },
        { label: t('general.UI.cancelSubscription'), value: 'cancel' }
    ];

    // State to track the selected option
    const [selectedOption, setSelectedOption] = useState(dropdownOptions[0]); // Default: "keep"

    return (
        <div className={styles.container}>
            <div className={styles.formobile}>
                <img src={HeroSectionCircle1} className={styles.HeroSectionCircle1} alt="" />
                <img src={HeroSectionCircle2} className={styles.HeroSectionCircle2} alt="" />
                <img src={HeroSectionCircle3} className={styles.HeroSectionCircle3} alt="" />
                <img src={HeroSectionCircle4} className={styles.HeroSectionCircle4} alt="" />
            </div>
            <div className={`${styles.container} ${styles.contentWrapper}`}>
                <div className={`${styles.heroSectionColumn} ${styles.heroSectionCircleForWeb}`}>
                    <img src={HeroSectionCircle1} className={styles.HeroSectionCircle1} alt="" />
                    <img src={HeroSectionCircle2} className={styles.HeroSectionCircle2} alt="" />
                    <img src={HeroSectionCircle3} className={styles.HeroSectionCircle3} alt="" />
                    <img src={HeroSectionCircle4} className={styles.HeroSectionCircle4} alt="" />
                </div>

                <div className={styles.heroSectionCenter} style={{ justifyContent: claim ? 'center' : "flex-start", gap: claim ? "10px" : '0px' }}>
                    {claim ?
                        <>
                            <p className={styles.heroTitle}>{title ? title : t('general.UI.verificationTitle')}</p>
                            <p className={styles.heroDesc} style={{ margin: '10px 0px' }}>{desc ? desc : t('general.UI.verificationDesc')}</p>
                        </>
                        :
                        <>
                            <p className={styles.heroDesc} style={{ margin: '10px 0px' }}>{desc ? desc : t('general.UI.verificationDesc')}</p>
                            <p className={styles.heroTitle}>{title ? title : t('general.UI.verificationTitle')}</p>
                        </>}
                    {!claim &&
                        <div className={styles.dropDownWrapper} >
                            <FormSelectField
                                type={'default'}
                                options={dropdownOptions}
                                hasBorder={true}
                                value={selectedOption}
                                onChange={(newOption) => {
                                    setSelectedOption(newOption);
                                    console.log("Selected option: ", newOption);
                                }}
                            />
                        </div>
                    }
                    <BubbleButton
                        headerButton
                        onClick={() => onSubmit(selectedOption, claim)}
                        className={'seePlansBtn'}
                    >
                        {claim ? t('general.UI.claim_free_subscription') : t('general.UI.submit')}
                    </BubbleButton>
                </div>
                <div className={`${styles.heroSectionColumn} ${styles.verifyBadge} ${styles.heroSectionVerificationContainer}`}                >
                </div>
            </div>
        </div>
    );
}

export default HeroSectionForCancellation;
